import { render, staticRenderFns } from "./LeadAddChildDialog.vue?vue&type=template&id=fc7544b0"
import script from "./LeadAddChildDialog.vue?vue&type=script&lang=ts"
export * from "./LeadAddChildDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports